module.exports = __webpack_public_path__ + "icon_asuminen.b5a7e7d77844ea7ae0e5.svg";